import React from 'react';
import { componentService } from 'js/services/component.service';

export const BonusHistory = React.lazy(() => import(/* webpackChunkName: "bonus-history" */ './BonusHistory'));

// <hub2-bonus-detail-balance></hub2-bonus-detail-balance>
componentService.registerWebContentComponents({ BonusDetailBalance: BonusHistory });
